import {createTheme} from "../../__snowpack__/pkg/@mui/material/styles.js";
import React, {useMemo} from "react";
import styled, {createGlobalStyle} from "styled-components";
import {InputContainer} from "../components/atoms/input/input.styles.js";
export const MainContainer = styled.main.withConfig({
  displayName: "generic-reactstyles__MainContainer",
  componentId: "sc-aaczp0-0"
})(["", ""], {
  display: "flex",
  flexDirection: "column",
  width: "100%"
});
export const FormTitleRowContainer = styled.div.withConfig({
  displayName: "generic-reactstyles__FormTitleRowContainer",
  componentId: "sc-aaczp0-1"
})(["", ""], {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  width: "100%",
  marginLeft: "-0.25rem",
  marginTop: "1.5rem",
  marginBottom: "0.5rem"
});
export const DEFAULT_THEME = {
  primaryColor: "#36475F",
  secondaryColor: "#2895F1",
  tertiaryColor: "#A9B1BC",
  successColor: "#7ED321",
  warningColor: "#F5A623",
  errorColor: "#CE3B4D",
  auxColor: "#861B89"
};
function ThemeStylesComponent({
  theme
} = {}) {
  const chosenColors = useMemo(() => ({
    ...DEFAULT_THEME,
    ...theme
  }), [theme]);
  const GlobalStyle = createGlobalStyle(["body{--primaryColor:", ";--secondaryColor:", ";--tertiaryColor:", ";--successColor:", ";--warningColor:", ";--errorColor:", ";--auxColor:", ";", "}"], chosenColors.primaryColor, chosenColors.secondaryColor, chosenColors.tertiaryColor, chosenColors.successColor, chosenColors.warningColor, chosenColors.errorColor, chosenColors.auxColor, {
    "--tw-text-opacity": "1",
    color: "rgba(42, 57, 78, var(--tw-text-opacity))",
    transitionProperty: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "200ms"
  });
  return /* @__PURE__ */ React.createElement(GlobalStyle, null);
}
export const ThemeStyles = /* @__PURE__ */ React.memo(ThemeStylesComponent);
export const DEFAULT_UI_THEME = {
  palette: {
    primary: {
      main: DEFAULT_THEME.primaryColor
    },
    secondary: {
      main: DEFAULT_THEME.secondaryColor
    },
    success: {
      main: DEFAULT_THEME.successColor
    },
    error: {
      main: DEFAULT_THEME.errorColor
    },
    warning: {
      main: DEFAULT_THEME.warningColor
    },
    info: {
      main: DEFAULT_THEME.tertiaryColor
    },
    tonalOffset: 0.2
  }
};
export function uiTheme({
  theme
} = {}) {
  const chosenColors = {
    ...DEFAULT_THEME,
    ...theme
  };
  const chosenTheme = {
    palette: {
      primary: {
        main: chosenColors.primaryColor
      },
      secondary: {
        main: chosenColors.secondaryColor
      },
      success: {
        main: chosenColors.successColor
      },
      error: {
        main: chosenColors.errorColor
      },
      warning: {
        main: chosenColors.warningColor
      },
      info: {
        main: chosenColors.tertiaryColor
      },
      tonalOffset: DEFAULT_UI_THEME.palette?.tonalOffset
    }
  };
  return createTheme(chosenTheme);
}
export const FormSection = styled.div.withConfig({
  displayName: "generic-reactstyles__FormSection",
  componentId: "sc-aaczp0-2"
})(["", " ", " ", "{", "}&&{.MuiBox-root{", "}.MuiFormControl-root{", "}}"], {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.75rem",
  flexDirection: "column"
}, ({
  isFirst
}) => !isFirst && {
  marginTop: "2.25rem"
}, InputContainer, {
  marginBottom: "1.5rem"
}, {
  width: "100%"
}, {
  width: "100%"
});
